/* iTechU trade-in selector. Digital Pulse original.
   Category, brand, model, storage, condition, quote. Reads its labels off
   data attributes so this file stays free of Liquid and serves as a static
   asset. The device rows are rendered once by Liquid into a hidden container
   and every tile above them is built from those rows here, because the
   catalogue arrives as several metafield chunks Liquid cannot merge. */
(function () {
  var root = document.querySelector('section.tri');
  if (!root) return;
  var src = root.querySelector('[data-src]');
  if (!src) return;

  var slot = root.querySelector('[data-slot]');
  var heading = root.querySelector('[data-heading]');
  var crumbs = root.querySelector('[data-crumbs]');
  var search = root.querySelector('[data-search]');
  var noneMsg = root.querySelector('[data-none-msg]');
  var conds = [].slice.call(root.querySelectorAll('.tri-cond'));
  var same = root.querySelector('[data-same]');
  var consoleNote = root.querySelector('[data-console-note]');
  var p2 = root.querySelector('[data-panel="2"]');
  var p3 = root.querySelector('[data-panel="3"]');
  var rails = [].slice.call(root.querySelectorAll('.tri-rail-i'));
  var fDevice = root.querySelector('[data-f-device]');
  var fCond = root.querySelector('[data-f-cond]');
  var fPrice = root.querySelector('[data-f-price]');
  var qPrice = root.querySelector('[data-qprice]');
  var qMeta = root.querySelector('[data-qmeta]');

  function attr(k, d) { var v = root.getAttribute(k); return v === null || v === '' ? (d || '') : v; }
  var L = {
    upto: attr('data-upto', 'Up to'),
    fallbackImg: attr('data-fallback-img'),
    cat: attr('data-h-cat', 'What are you selling?'),
    brand: attr('data-h-brand', 'Who makes it?'),
    model: attr('data-h-model', 'Which model is it?'),
    storage: attr('data-h-storage', 'How much storage?'),
    spec: attr('data-h-spec', 'Which configuration?'),
    results: attr('data-h-results', 'Matching devices'),
    none: attr('data-none', 'Nothing matches that.')
  };

  /* The condition and quote panels are taller than the viewport, so the old
     scrollIntoView block:'center' left the top of the panel above the fold and
     read as a jump towards the bottom of the page. Align the top of the panel
     instead, clearing whatever sticky header is on screen. */
  function headerOffset() {
    var h = 0;
    var els = document.querySelectorAll('header, [class*="header"], [id*="header"], [data-sticky-header]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      var r = el.getBoundingClientRect();
      if (r.top > 80 || r.height < 30) continue;
      if (r.height > h) h = r.height;
    }
    return h > 160 ? 160 : h;
  }
  function scrollToPanel(el) {
    if (!el) return;
    var go = function () {
      var top = window.pageYOffset || document.documentElement.scrollTop || 0;
      var y = el.getBoundingClientRect().top + top - headerOffset() - 24;
      if (y < 0) y = 0;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); }
      catch (e) { window.scrollTo(0, y); }
    };
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () { window.requestAnimationFrame(go); });
    } else {
      setTimeout(go, 30);
    }
  }

  var rows = [].slice.call(src.querySelectorAll('.tri-cap')).map(function (el) {
    return {
      cat: el.getAttribute('data-category') || 'Phone',
      brand: el.getAttribute('data-brand') || '',
      model: el.getAttribute('data-model') || '',
      storage: el.getAttribute('data-storage') || '',
      e: Number(el.getAttribute('data-e')) || 0,
      g: Number(el.getAttribute('data-g')) || 0,
      f: Number(el.getAttribute('data-f')) || 0,
      np: Number(el.getAttribute('data-np')) || 0,
      sort: Number(el.getAttribute('data-sort')) || 9999999,
      img: el.getAttribute('data-img') || ''
    };
  });
  if (!rows.length) return;
  rows.sort(function (a, b) { return a.sort - b.sort; });

  var PLURAL = { Phone: 'Phones', Tablet: 'Tablets', MacBook: 'MacBooks', Console: 'Consoles' };
  function catLabel(c) { return PLURAL[c] || c; }
  function specHeading(c) { return c === 'MacBook' ? L.spec : L.storage; }

  function money(n) {
    var v = Number(n) || 0;
    var dp = (Math.round(v * 100) % 100 === 0) ? 0 : 2;
    return '£' + v.toLocaleString('en-GB', { minimumFractionDigits: dp, maximumFractionDigits: dp });
  }
  function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : 's'); }
  function rail(n) {
    rails.forEach(function (r) {
      var k = Number(r.getAttribute('data-rail'));
      if (k <= n) { r.classList.add('is-on'); } else { r.classList.remove('is-on'); }
    });
  }

  /* group a row list by a key, preserving the sort order already applied */
  function groupBy(list, key) {
    var seen = {}, order = [];
    list.forEach(function (r) {
      var k = r[key];
      if (!seen[k]) { seen[k] = { key: k, rows: [], top: 0, models: {}, img: '' }; order.push(seen[k]); }
      var b = seen[k];
      b.rows.push(r);
      if (r.e > b.top) b.top = r.e;
      b.models[r.model] = 1;
      if (!b.img && r.img) b.img = r.img;
    });
    order.forEach(function (b) { b.modelCount = Object.keys(b.models).length; });
    return order;
  }

  var art = {};
  [].slice.call(root.querySelectorAll('template[data-art]')).forEach(function (t) {
    art[t.getAttribute('data-art')] = t;
  });
  function artFor(cat) { return art[cat] || art._ || null; }

  function makeArt(cat, img) {
    var wrap = document.createElement('span');
    wrap.className = 'tri-mart';
    var use = img || L.fallbackImg;
    if (use) {
      var im = document.createElement('img');
      im.src = use; im.alt = ''; im.width = 130; im.height = 130;
      im.loading = 'lazy'; im.decoding = 'async';
      wrap.appendChild(im);
    } else {
      var t = artFor(cat);
      if (t && t.content) wrap.appendChild(t.content.cloneNode(true));
    }
    return wrap;
  }

  function tile(opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tri-model' + (opts.compact ? ' tri-model--compact' : '');
    if (opts.art) b.appendChild(makeArt(opts.cat, opts.img));
    var nm = document.createElement('span');
    nm.className = 'tri-mname'; nm.textContent = opts.title;
    b.appendChild(nm);
    if (opts.sub) {
      var sb = document.createElement('span');
      sb.className = 'tri-msub'; sb.textContent = opts.sub;
      b.appendChild(sb);
    }
    if (opts.note) {
      var fr = document.createElement('span');
      fr.className = 'tri-mfrom'; fr.textContent = opts.note;
      b.appendChild(fr);
    }
    b.addEventListener('click', opts.onPick);
    return b;
  }

  var state = { cat: null, brand: null, model: null, storage: '', prices: {}, cond: null, stage: 'cat' };

  function resetFrom(stage) {
    if (stage === 'cat') { state.cat = null; state.brand = null; state.model = null; }
    if (stage === 'brand') { state.brand = null; state.model = null; }
    if (stage === 'model') { state.model = null; }
    state.storage = ''; state.prices = {}; state.cond = null;
    conds.forEach(function (c) {
      c.classList.remove('is-on');
      var v = c.querySelector('[data-cval]'); if (v) v.textContent = '';
    });
    if (same) same.hidden = true;
    if (consoleNote) consoleNote.hidden = true;
    if (p2) p2.hidden = true;
    if (p3) p3.hidden = true;
    rail(1);
  }

  function drawCrumbs() {
    if (!crumbs) return;
    crumbs.textContent = '';
    var items = [];
    if (state.cat) items.push({ label: catLabel(state.cat), to: 'cat' });
    if (state.brand) items.push({ label: state.brand, to: 'brand' });
    if (state.model) items.push({ label: state.model, to: 'model' });
    if (!items.length) { crumbs.hidden = true; return; }
    crumbs.hidden = false;
    items.forEach(function (it, i) {
      if (i) {
        var sep = document.createElement('span');
        sep.className = 'tri-crumb-sep'; sep.textContent = '›'; sep.setAttribute('aria-hidden', 'true');
        crumbs.appendChild(sep);
      }
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'tri-crumb'; b.textContent = it.label;
      b.addEventListener('click', function () {
        if (search) search.value = '';
        resetFrom(it.to);
        state.stage = it.to;
        draw();
      });
      crumbs.appendChild(b);
    });
  }

  function show(list, headingText) {
    slot.textContent = '';
    slot.hidden = false;
    if (noneMsg) noneMsg.hidden = true;
    if (heading) { heading.hidden = false; heading.textContent = headingText; }
    var frag = document.createDocumentFragment();
    list.forEach(function (n) { frag.appendChild(n); });
    slot.appendChild(frag);
  }

  /* Each condition's description textarea holds one criterion per line. More
     than one line renders as a ticked checklist (the "modern, Mazuma-style"
     look Luke asked for); a single line (the No power tier, and any
     console override that hasn't been rewritten as a list) just renders as
     plain text, unchanged from before. */
  var TICK_SVG = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M7.6 13.4 4.3 10.1 3 11.4l4.6 4.6L17 6.6l-1.3-1.3z" fill="currentColor"/></svg>';

  function renderChecklist(descEl, text) {
    var lines = (text || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
    descEl.textContent = '';
    if (lines.length > 1) {
      var ul = document.createElement('ul');
      ul.className = 'tri-cchecks';
      lines.forEach(function (line) {
        var li = document.createElement('li');
        li.className = 'tri-ctick';
        var ic = document.createElement('span');
        ic.className = 'tri-ctick-ic';
        ic.innerHTML = TICK_SVG;
        var tx = document.createElement('span');
        tx.className = 'tri-ctick-tx';
        tx.textContent = line;
        li.appendChild(ic);
        li.appendChild(tx);
        ul.appendChild(li);
      });
      descEl.appendChild(ul);
    } else {
      descEl.textContent = lines[0] || '';
    }
  }

  /* Condition-band descriptions are written for phones by default. Consoles
     read differently in practice (no battery health, no iCloud lock — but
     disc drives, ports and fans instead), so each condition block can carry
     an optional console-specific override. Swap it in here whenever the
     customer's current category is Console, otherwise show the default.
     The blanket "we can't buy this" exclusion note is also console-only,
     shown once beneath the whole grid rather than repeated on every card. */
  function applyConditionCopy() {
    var isConsole = state.cat === 'Console';
    conds.forEach(function (c) {
      var descEl = c.querySelector('[data-cdesc]');
      if (!descEl) return;
      var consoleBlurb = c.getAttribute('data-blurb-console');
      var defaultBlurb = c.getAttribute('data-blurb');
      var text = (isConsole && consoleBlurb) ? consoleBlurb : defaultBlurb;
      renderChecklist(descEl, text);
    });
    if (consoleNote) consoleNote.hidden = !isConsole;
  }

  function pickStorage(r) {
    state.storage = r.storage;
    state.prices = { excellent: r.e, good: r.g, faulty: r.f, no_power: r.np };
    state.cond = null;
    applyConditionCopy();
    conds.forEach(function (c) {
      c.classList.remove('is-on');
      var v = c.querySelector('[data-cval]');
      if (v) v.textContent = money(state.prices[c.getAttribute('data-key')]);
    });
    if (same) same.hidden = !(Number(state.prices.excellent) === Number(state.prices.good));
    if (p2) p2.hidden = false;
    if (p3) p3.hidden = true;
    rail(2);
    scrollToPanel(p2);
  }

  function enterModel(cat, brand, model) {
    state.cat = cat; state.brand = brand; state.model = model;
    var mine = rows.filter(function (r) { return r.cat === cat && r.brand === brand && r.model === model; });
    if (mine.length === 1) {
      /* only one configuration, so there is nothing to choose. Hide the tile
         area and its heading rather than leaving a heading over empty space. */
      state.stage = 'model';
      drawCrumbs();
      slot.hidden = true;
      if (heading) heading.hidden = true;
      pickStorage(mine[0]);
      return;
    }
    state.stage = 'storage';
    draw();
  }

  function draw() {
    drawCrumbs();
    var q = search ? search.value.trim().toLowerCase() : '';

    if (q) {
      var hits = [];
      var seenModel = {};
      rows.forEach(function (r) {
        var k = r.cat + '|' + r.brand + '|' + r.model;
        if (seenModel[k]) return;
        var hay = (r.brand + ' ' + r.model).toLowerCase();
        if (hay.indexOf(q) === -1) return;
        seenModel[k] = 1;
        var top = 0;
        rows.forEach(function (o) {
          if (o.cat === r.cat && o.brand === r.brand && o.model === r.model && o.e > top) top = o.e;
        });
        hits.push(tile({
          title: r.model, sub: r.brand, cat: r.cat, img: r.img, art: true,
          note: L.upto + ' ' + money(top),
          onPick: function () { if (search) search.value = ''; enterModel(r.cat, r.brand, r.model); }
        }));
      });
      if (!hits.length) {
        slot.textContent = ''; slot.hidden = true;
        if (heading) { heading.hidden = false; heading.textContent = L.results; }
        if (noneMsg) { noneMsg.textContent = L.none; noneMsg.hidden = false; }
        return;
      }
      show(hits, L.results);
      return;
    }

    if (state.stage === 'cat') {
      var cats = groupBy(rows, 'cat');
      if (cats.length === 1) { state.cat = cats[0].key; state.stage = 'brand'; draw(); return; }
      show(cats.map(function (c) {
        return tile({
          title: catLabel(c.key), cat: c.key, art: true,
          note: plural(c.modelCount, 'model'),
          onPick: function () { state.cat = c.key; state.stage = 'brand'; draw(); }
        });
      }), L.cat);
      return;
    }

    if (state.stage === 'brand') {
      var inCat = rows.filter(function (r) { return r.cat === state.cat; });
      var brands = groupBy(inCat, 'brand');
      if (brands.length === 1) { state.brand = brands[0].key; state.stage = 'model'; draw(); return; }
      show(brands.map(function (b) {
        return tile({
          title: b.key, cat: state.cat, compact: true,
          note: plural(b.modelCount, 'model'),
          onPick: function () { state.brand = b.key; state.stage = 'model'; draw(); }
        });
      }), L.brand);
      return;
    }

    if (state.stage === 'model') {
      var inBrand = rows.filter(function (r) { return r.cat === state.cat && r.brand === state.brand; });
      var models = groupBy(inBrand, 'model');
      show(models.map(function (m) {
        return tile({
          title: m.key, cat: state.cat, img: m.img, art: true,
          note: L.upto + ' ' + money(m.top),
          onPick: function () { enterModel(state.cat, state.brand, m.key); }
        });
      }), L.model);
      return;
    }

    if (state.stage === 'storage') {
      var mine = rows.filter(function (r) {
        return r.cat === state.cat && r.brand === state.brand && r.model === state.model;
      });
      show(mine.map(function (r) {
        return tile({
          title: r.storage || 'Standard', cat: state.cat, compact: true,
          note: L.upto + ' ' + money(r.e),
          onPick: function () { pickStorage(r); }
        });
      }), specHeading(state.cat));
    }
  }

  if (search) {
    search.addEventListener('input', function () {
      if (search.value.trim()) { resetFrom('cat'); state.stage = 'cat'; }
      draw();
    });
  }

  conds.forEach(function (c) {
    c.addEventListener('click', function () {
      if (!state.model || state.prices.excellent === undefined) return;
      conds.forEach(function (o) { o.classList.remove('is-on'); });
      c.classList.add('is-on');
      state.cond = c.getAttribute('data-key');
      var price = state.prices[state.cond];
      var tEl = c.querySelector('.tri-ctitle');
      var label = tEl ? tEl.textContent.trim() : state.cond;
      var dev = state.brand + ' ' + state.model + (state.storage ? ' (' + state.storage + ')' : '');
      if (qPrice) qPrice.textContent = money(price);
      if (qMeta) qMeta.textContent = dev + ', ' + label;
      if (fDevice) fDevice.value = dev;
      if (fCond) fCond.value = label;
      if (fPrice) fPrice.value = money(price);
      if (p3) p3.hidden = false;
      rail(3);
      scrollToPanel(p3);
    });
  });

  var rs = root.querySelector('[data-restart]');
  if (rs) rs.addEventListener('click', function () {
    if (search) search.value = '';
    resetFrom('cat');
    state.stage = 'cat';
    draw();
    scrollToPanel(root);
  });

  applyConditionCopy();
  draw();
})();
